var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon18Bell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.136 12L5.021 11.1135C5.3045 10.83 5.4605 10.4535 5.4605 10.053V6.54528C5.4605 5.52753 5.903 4.55478 6.6755 3.87828C7.454 3.19578 8.4455 2.89578 9.47825 3.03153C11.2235 3.26328 12.5398 4.84128 12.5398 6.70278V10.053C12.5398 10.4535 12.6958 10.83 12.9785 11.1128L13.8643 12H4.136ZM10.4998 13.7558C10.4998 14.43 9.81276 15 8.99976 15C8.18676 15 7.49976 14.43 7.49976 13.7558V13.5H10.4998V13.7558ZM15.3905 11.406L14.0398 10.053V6.70278C14.0398 4.09203 12.1633 1.87428 9.67476 1.54503C8.23326 1.35303 6.77826 1.79328 5.68701 2.75028C4.58901 3.71178 3.96051 5.09478 3.96051 6.54528L3.95976 10.053L2.60901 11.406C2.25726 11.7585 2.15301 12.2828 2.34351 12.7425C2.53476 13.203 2.97951 13.5 3.47751 13.5H5.99976V13.7558C5.99976 15.2693 7.34526 16.5 8.99976 16.5C10.6543 16.5 11.9998 15.2693 11.9998 13.7558V13.5H14.522C15.02 13.5 15.464 13.203 15.6545 12.7433C15.8458 12.2828 15.7423 11.7578 15.3905 11.406Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon18Bell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_18_bell.64168769.svg";
export { ForwardRef as ReactComponent };